/* eslint-disable angular/ng_angularelement */
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalVideo from '../../shared/components/modal-video/modal-video.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';
import modalRecommendProduct from '../../shared/components/modal-recommend-product/modal-recommend-product.view.html';
import modalCommentsController from '../modal-comments/modal-comments.view.html';
import angular from 'angular';

let inject = [
    '$scope',
    'CategoryService',
    '$state',
    '$rootScope',
    'SharedService',
    '$stateParams',
    '$uibModal',
    'ProductDetailService',
    '$timeout',
    'CatalogService',
    'CartService',
    'SessionService',
    '$mdToast',
    'ByFavoritesService',
    '$window'
];

class ProductDetailController {
    constructor($scope,
                CategoryService,
                $state,
                $rootScope,
                SharedService,
                $stateParams,
                $uibModal,
                ProductDetailService,
                $timeout,
                CatalogService,
                CartService,
                SessionService,
                $mdToast,
                ByFavoritesService,
                $window) {
        this.$state = $state;
        this.$scope = $scope;
        this.CatalogService = CatalogService;
        this.ProductDetailService = ProductDetailService;
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.CartService = CartService;
        this.SessionService = SessionService;
        this.CategoryService = CategoryService;
        this.SharedService = SharedService;
        this.$timeout = $timeout;
        this.loanding = false;
        this.$mdToast = $mdToast;
        this.showProductPrice = true;
        this.partSuppliesProduct = [];
        this.featuredProducts = [];
        this.active = 0;
        this.partSustitutesProduct = [];
        this.partSparesProducts = [];
        this.showBottomAddCart = true;
        this.productQuantity = 1;
        this.productId = this.$stateParams.productId || '';
        this.productSlug = this.$stateParams.productSlug || '';
        this.title = document.title;
        this.comments = [];
        this.globalRating = 0;
        this.globalRatingDecimal = 0;
        this.hasCommented = false;
        this.commentDataForm = {};
        this.ratingSelected = false;
        this.attributesDetail;
        this.property = 'date';
        this.reverse = false;
        this.imageVisor = null;
        this.imageZoom = null;

        this.pageNumber = 0;
        this.loadingComments = false;
        this.finishComments = false;

        this.dataCart = {};
        this.dataProducs = {};

        this.ByFavoritesService = ByFavoritesService;

        this.productItems = {};
        // only for adaptative
        this.showComments = false;
        this.originalClonedAttributesArray = null;
        this.colorSizeRelationArray = null;


        this.pageName = "PAG-22";
        this.SharedService.getCMSBanners(this.pageName).then(response => {
            this.cmsData = response;
        });
    }

    $onInit() {
        this.getProductDetail();
    }

    $onDestroy() {
        document.title = this.title;
        var myEl = angular.element(document.querySelector('.zoomContainer'));
        myEl.remove();
    }

    updateFavoriteProducts(product) {

        product.isSettingAsFavorite = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        if (userId) {

            let data = {
                'productId': product.id,
                'userId': userId,
                'setFavorite': !product.isFavorite
            };
            this.CatalogService.updateFavoriteProducts(data).then(response => {
                product.isFavorite = !product.isFavorite;
                product.isSettingAsFavorite = false;

                if (!response.error) {
                    this.ByFavoritesService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
                        this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
                        this.SessionService.put('globals', this.shCtrl.globals);

                    });
                }

            }).catch(error => {
                product.isSettingAsFavorite = false;
                if (__env.adaptative) {
                    this.messageMaterial('Ha ocurrido un error al actualizar el producto');
                } else {
                    let options = {
                        title: '',
                        isHtml: false,
                        content: 'Ha ocurrido un error al actualizar el producto',
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };

                    this.messageResponse(options);
                }
            });
        }
    }

    onItemRating(rating) {
        this.commentDataForm["rating"] = rating;
        this.ratingSelected = rating === 0;
    }

    openCommentsModal() {

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }

        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalCommentsController,
            controller: 'ModalCommentsController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                product: () => this.productDetail,
                userId: () => userId
            }
        });
        modalInstance.result.then(result => {

            let options = {
                title: '',
                isHtml: true,
                content: result.message,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);

        }).catch(error => {
            console.log(error);
        });
    }

    getProductComments() {

        if (this.loadingComments) return;

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }

        this.loadingComments = true;
        this.pageNumber++;

        this.ProductDetailService.getProductComments(this.productDetail.id, userId).then(val => {

            if (!val.error) {

                this.globalRating = val.globalRating;
                this.globalRatingDecimal = val.globalRatingDecimal;
                this.comments = [];
                val.data.forEach(value => {
                    this.comments.push({
                        rate: value.puntaje,
                        title: value.titulo,
                        description: value.comentario,
                        user: value.usuario_nombre,
                        date: value.fecha
                    });
                });
            }

            if (val.data.length > 0) {
                this.loadingComments = false;
            } else {
                this.finishComments = true;
            }

        }).catch(err => {
            console.log(err);
        });
    }

    submitCommentad(submitForm) {

        if (submitForm.$valid && this.commentDataForm.rating > 0) {

            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            } catch (e) {
            }

            let params = {
                item_id: this.productDetail.id,
                puntaje: this.commentDataForm.rating,
                titulo: this.commentDataForm.title,
                comentario: this.commentDataForm.comment,
                user_id: userId
            };

            this.ProductDetailService.setProductComments(params).then(value => {

                if (!value.error) {
                    this.loadingComments = false;
                    this.finishComments = false;
                    this.pageNumber = 0;
                    this.getProductComments();
                }
                if (__env.adaptative) {
                    this.messageMaterial(value.message);
                    this.commentDataForm.comment = '';
                    this.commentForm.$setPristine();
                    this.commentForm.$setUntouched();
                } else {
                    let options = {
                        title: '',
                        isHtml: true,
                        content: value.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);

                }

            }).catch(err => {
                console.log(err);
            });

        } else {
            angular.forEach(submitForm.$error.required, function (field) {
                field.$setDirty();
            });

            if (this.commentDataForm.rating === 0 || !this.ratingSelected) {
                this.ratingSelected = true;
            }
        }
    }

    getProductDetail() {
        this.loadingProductDetail = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }

        this.ProductDetailService.getProductDetail(this.productId, this.productSlug, userId).then(response => {
            this.loadingProductDetail = false;
            try {


              if (response != 'false'){
                this.productDetail = response;
                this.originalClonedAttributesArray = this.productDetail.clonedAttributesDetail;
                this.colorSizeRelationArray = this.productDetail.colorSizeRelationArray;
                this.productQuantity = response.cantidad_minima;

                this.$window.dataLayer = this.$window.dataLayer || [];
                this.$window.dataLayer.push({
                  'event': 'Pageview',
                  'ecommerce': {
                    'detail': {
                      'actionField': {'list': 'Product'},    // 'detail' actions have an optional list property.
                      'products': [{
                        'name': response.name,         // Name or ID is required.
                        'id': response.id,
                        'price': response.currentPrice,
                        'category': response.category.slug,
                      }]
                    }
                  }
                });

                if (this.productDetail.canonical){
                  var meta = document.createElement('link');
                  meta.setAttribute('rel', 'canonical');
                  meta.setAttribute('href', __env.frontPath + 'shop/'+this.productDetail.canonical);
                  document.head.appendChild(meta);
                }

                this.$rootScope.$emit('onChangeCompany',response.company);
                this.productDetail.seo["url_imagen"]=this.productDetail.imagesDetail[0].path + this.productDetail.imagesDetail[0].image;
                this.productDetail.seo["slug"]= "shop/" + this.productDetail.slug;
                this.shCtrl.setTags(this.productDetail.seo);

                this.imageVisor = this.productDetail.imagesDetail[0].path + this.productDetail.imagesDetail[0].image;

                this.productoPlantilla = response;



                this.initPluginsProductDetails();

                this.getRelatedProducts();
                this.getProductComments();

                if (!angular.isArray(response.attributesDetail)) {
                  //console.log(response.attributesDetail);
                  this.attributesDetail = response.attributesDetail;
                }

                if (this.productDetail.clonedAttributesDetail.length > 0) {
                    this.showProductPrice = false;
                }

                if (this.productDetail.isTemplate) {
                    this.productTemplateCopy = angular.copy(this.productDetail);
                }
                document.title = this.productDetail.name;
                } else {
                    this.$state.go('home.productSearch', {searchText: this.productSlug});
                }

                this.initFirstAttributesSelected();

            }
            catch (e) {
                this.$state.go('/404');
            }
        }).catch(reason => {
            this.$state.go('/404');
        });
    }

    setItemToAddToCart(product) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalQuantityCart,
            controller: 'ModalQuantityCartController',
            controllerAs: 'mdCtrl',
            size: 'sm',
            resolve: {
                product: () => product
            }
        });
        modalInstance.result.then(result => {
            if (result.product.id && result.quantity) {
                let userId = '', cart = null;
                try {
                    userId = this.shCtrl.globals.currentUser.userId;
                } catch (e) {
                }
                try {
                    cart = this.shCtrl.cart;
                } catch (e) {
                }

                let validation = this.SessionService.validateFactorItems(result.quantity, product);

                if (validation.error) {
                    let options = {
                        title: '',
                        isHtml: true,
                        content: validation.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                    return;
                }

                this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {
                    if (!response.error) {
                        // this.$scope.$emit('onUpdateCart');

                        // let modalInstance2 = this.$uibModal.open({
                        //     animation: true,
                        //     template: modalConfirmationCart,
                        //     controller: 'ModalConfirmationController',
                        //     controllerAs: 'mdCtrl',
                        //     size: 'lg',
                        //     resolve: {
                        //         product: () => product
                        //     }
                        // });
                        this.dataCart = {};
                        this.dataProducs = {};
                        this.modalConfirmation(product, result.quantity);
                    } else {
                        if (response.agotado) {
                            product.cantidad = response.itemStock;
                            this.CartService.updateItemsNotAvailable(product, result.quantity, userId);
                        }
                        let options = {
                            title: '',
                            isHtml: true,
                            content: response.message,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }
                }).catch(reason => {
                    let options = {
                        title: '',
                        isHtml: false,
                        content: reason,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                });
            }
        }).catch(error => {

        });
    }

    getRelatedProducts() {
        this.loadingRelatedProducts = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }

        this.ProductDetailService.getRelatedProducts(this.productDetail.id, userId, this.productSlug).then(response => {
            this.relatedProducts = response;
            response.forEach(item => {

                if (item.id_tipo_relacion == '1') {
                    this.partSuppliesProduct.push(item);
                }
                if (item.id_tipo_relacion == '2') {
                    this.partSustitutesProduct.push(item);
                }
                if (item.id_tipo_relacion == '3') {
                    this.partSparesProducts.push(item);
                }
            });
            this.loadingRelatedProducts = false;
        }).catch(reason => {

        })
    }

    addItemToCart(product, quantity) {
        if (product.id && quantity) {
            let userId = '', cart = null;
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            } catch (e) {
            }
            try {
                cart = this.shCtrl.cart;
            } catch (e) {
            }

            let validation = this.SessionService.validateFactorItems(quantity, product);

            if (validation.error) {

                let options = {
                    title: '',
                    isHtml: true,
                    content: validation.message,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
                return;
            }

            this.CartService.addItemToCart(product, quantity, null, null, userId, cart).then(response => {
                if (!response.error) {
                    this.dataCart = {};
                    this.dataProducs = {};

                    let discountItem = 0;

                    if(response.discountItem > 0){
                      discountItem = response.discountItem;
                    }

                    this.modalConfirmation(product, quantity, discountItem);
                    this.$window.dataLayer.push({
                      'event': 'addToCart',
                      'ecommerce': {
                        'add': {
                          'products': [{                        //  adding a product to a shopping cart.
                            'name': product.name,
                            'id': product.id,
                            'price':  product.currentPrice,
                            'category': product.category.slug,
                            'quantity': quantity
                          }]
                        }
                      }
                    });

                } else {

                    if (response.agotado) {
                        product.cantidad = response.itemStock;
                        this.CartService.updateItemsNotAvailable(product, quantity, userId);
                    }
                    let options = {
                        title: '',
                        isHtml: true,
                        content: response.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                }
            }).catch(reason => {
                let options = {
                    title: '',
                    isHtml: false,
                    content: reason,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            });
        }
    }

    static clickgaleria() {
        //click en la imagen con lupa grande para que popup se despliegue.
        $("#product-image-carousel-container ul li a").eq(0).trigger('click');
    }

    recommendProduct() {
        this.$uibModal.open({
            animation: true,
            template: modalRecommendProduct,
            controller: 'ModalRecommendProductController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                product: () => this.productDetail
            }
        });
    }

    initFirstAttributesSelected(){
        let keepGoing = true;
        let select = [];
        angular.forEach(this.productDetail.clonedAttributesDetail[0].value, function (value, key) {
            value = value || '';
            if (value && keepGoing) {
              //  vm.clonedAttributesSelectedLength++;

                select=key;

                keepGoing = false;
            }
        });
        this.clonedFormData={"unidaddemedida": select};
        this.clonedAttributesSelected(this.clonedFormData);
    }

    clonedAttributesSelected(attributeName) {

        this.clonedAttributesSelectedLength = 0;
        let vm = this;

        this.clonedProductPrice = '';
        this.showProductPrice = false;
        this.showBottomAddCart = true;
        this.messageClonedProductPrice = '';

        angular.forEach(this.clonedFormData, function (value, key) {
            value = value || '';
            if (value) {
                vm.clonedAttributesSelectedLength++;
            }
        });

        if (this.productDetail.clonedAttributesDetail.length === this.clonedAttributesSelectedLength) {
            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {
            }
            this.loadingClonedProductPrice = true;
            let data = {
                'productTemplateId': this.productTemplateCopy.id,
                'attributes': this.clonedFormData,
                'userId': userId
            };
            this.loadingClonedProductPrice = true;
            this.showBottomAddCart = false;

            this.ProductDetailService.clonedProductPrice(data).then(response => {

                this.loadingClonedProductPrice = false;
                this.showBottomAddCart = true;

                if (!response.error) {
                    this.showProductPrice = true;
                    this.productDetail.currentPrice = response.data.currentPrice;
                    this.productDetail.preciosxvolumen = response.data.preciosxvolumen;
                    this.productDetail.discountValue = response.data.discountValue;
                    this.productDetail.discountPercentage = response.data.discountPercentage;

                    this.productDetail.clonedId = response.data.clonedId;

                    this.productDetail.quote = response.data.quote;
                    this.productDetail.textLabel = response.data.textLabel;
                    this.productDetail.textLabelContinue = response.data.textLabelContinue;
                    this.productDetail.textAction = response.data.textAction;

                    // Replace the template item for the real item
                    this.productQuantity = response.data.dataItem.cantidad_minima;
                    this.productDetail = response.data.dataItem;
                    // this.productDetail.clonedAttributesDetail = this.productTemplateCopy.clonedAttributesDetail;
                    this.productDetail.clonedAttributesDetail = angular.copy(this.productTemplateCopy.clonedAttributesDetail);
                    this.loadedItemFromTemplate = true;
                    // Restart pretty photo
                }
                else {
                    this.messageClonedProductPrice = 'Producto no disponible';
                    this.productDetail = angular.copy(this.productTemplateCopy);
                    this.loadedItemFromTemplate = false;

                }
            }).catch(reason => {
                this.loadingClonedProductPrice = false;
                alert('Error al obtener el precio del producto');
            });
        }
        else {
            // Recover the template
            this.productDetail = angular.copy(this.productTemplateCopy);
            this.loadedItemFromTemplate = false;

            this.productDetail.discountValue = 0;
            this.productDetail.discountPercentage = 0;

        }

        if(attributeName === 'extensioncolor') {
            this.filterAttributesDetail(this.originalClonedAttributesArray);
        }

        return false;
    }


    ProductQuantity() {
      this.productQuantity = parseInt(this.productQuantity)
    }

    increaseProductQuantity() {
        this.productQuantity++;
    }

    getFeaturedProducts() {
        let userId = '';
        try {
            userId = this.shCtrl.currentUser.userId;
        }
        catch (e) {
        }
        this.CatalogService.getFeaturedProducts(userId, 3).then(response => {
            this.featuredProducts = response;
            //this.initRelatedProductsCarousel();
        }).catch(reason => {

        });
    }

    initRelatedProductsCarousel() {
        this.$timeout(() => {
            let owlfeatured = $("#featured-items-slider");
            owlfeatured.owlCarousel({
                items: 1,
                itemsDesktop: [1199, 1],
                itemsDesktopSmall: [979, 1],
                itemsTablet: [768, 1],
                itemsMobile: [479, 1],
                slideSpeed: 400,
                autoPlay: 5000,
                stopOnHover: true,
                navigation: false,
                pagination: false,
                responsive: true,
                mouseDrag: false,
                autoHeight: true
            });

            // Custom Navigation Events Featured
            $("#featured-items-slider-next").click(function () {
                owlfeatured.trigger('owl.next');
            });
            $("#featured-items-slider-prev").click(function () {
                owlfeatured.trigger('owl.prev');
            });
        }, 100);
    }

    decreaseProductQuantity() {
        if (this.productQuantity > 1)
            this.productQuantity--;
    }

    initProductImagesViewer() {
        this.initPluginsProductDetails();
        this.$timeout(() => {
            $('#product-image-carousel-container').find('li:first-child a').mouseover();
        }, 1000);
    }

    openVideo(video) {
        let options = {
            video: video,
            propertySrc: 'url'
        };

        this.$uibModal.open({
            animation: true,
            template: modalVideo,
            controller: 'ModalVideoController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
    }

    initPluginsProductDetails() {
        this.$timeout(() => {
            $('.related-slider.flexslider').flexslider({
                animation: "slide",
                selector: ".related-list > li",
                controlNav: false, // false
                prevText: '',
                nextText: '',
                smoothHeight: true,
                slideshowSpeed: 7000
            });
            // Pretty Photo

            // Carousel
            this.carouselContainer = $('#product-carousel');
            if ($.fn.elastislide) {
                this.carouselContainer.elastislide({
                    minItems: 1
                });
            }
            // Product page zoom plugin settings
            this.productImg = $('#product-image');
            if (!__env.adaptative) {
                this.changeZoom(this.productImg[0].src);
                if ($.fn.elevateZoom) {
                    this.carouselContainer.find('a').on('mouseover', (e) => {
                        let ez = $('#product-image').data('elevateZoom'),
                            smallImg = $(this).data('image'),
                            bigImg = $(this).data('zoom-image');
                        ez.swaptheimage(smallImg, bigImg);
                        e.preventDefault();
                    });

                }
            }

        }, 100);
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 7000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
            '  <span class="md-toast-text">' + text + '</span>\n' +
            '  <md-button ng-click="toast.closeToast()">\n' +
            '    Cerrar\n' +
            '  </md-button>\n' +
            '</md-toast>'
        });
    }

    changImage(path, img) {

        this.imageVisor = path + img;
        if (!__env.adaptative) {
            this.imageZoom = path + img;
            this.changeZoom(this.imageZoom);
        }
    }

    changeZoom(path) {
        this.productImg.data('zoom-image', path).elevateZoom({
            responsive: true, // simple solution for zoom plugin down here // it can cause bugs at resize
            zoomType: (self.mobile || $(window).width() < 768) ? 'inner' : 'window', // you can use 'inner' or 'window' // change inner and go to product.html page and see zoom plugin differances
            borderColour: '#d0d0d0',
            cursor: "crosshair",
            borderSize: 3,
            lensSize: 100,
            lensShape: "square",
            lenszoom: true,
            easingDuration: 1000,
            lensOpacity: 1,
            scrollZoom: true,
            zoomWindowWidth: 400,
            zoomWindowHeight: 400,
            lensColour: 'rgba(255, 255, 255, 0.25)'
        });
    }

    modalConfirmation(products, quantity, discount = null) {

      this.productAdded = products;
      this.productAdded.activateVolumenPrice = products.activateVolumenPrice;
      this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
      this.productAdded.price = products.itemPrice;
      this.productAdded.discount = discount * quantity;
      //this.productAdded.ivaValue = products.taxValue;
      this.productAdded.quantity = quantity;

      let taxValues  = ((products.itemPrice -  discount)  * products.taxPercentage / 100);
      this.productAdded.ivaValue = taxValues * quantity;
      if (products.preciosxvolumen == null) {
        this.productAdded.total = (products.itemPrice - discount + taxValues) * quantity;
      }

      else if (!products.preciosxvolumen[2] && !products.preciosxvolumen[1]) {
        if (products.quantity > products.preciosxvolumen[0].hasta){
          this.productAdded.total = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
        }
        else {
          this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
        }
      }

      else if (!products.preciosxvolumen[2]){
        if (products.quantity > products.preciosxvolumen[1].hasta){
          this.productAdded.total = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
        }
        else {
          this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
          this.productAdded.totalpxv2 = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
        }
      }

      else {
          this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
          this.productAdded.totalpxv2 = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
          this.productAdded.totalpxv3 = (products.preciosxvolumen[2].itemPrice - products.preciosxvolumen[2].itemDiscount + products.preciosxvolumen[2].taxValue) * quantity;
        }




        if (__env.adaptative) {
            this.messageMaterial(products.name + ' Ha sido agregado correctamente')
        } else {
            $('#ModalproductDetail').modal('toggle');
        }

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

    //Intersecta arrays originalClonedAttributesArray con this.colorSizeRelationArray
    // Para hallar que tallas se deben mostrar segun que color.
    filterAttributesDetail(originalClonedAttributesArray) {

        //logica de seleccion
        if(this.clonedFormData.extensioncolor != undefined) {
            //Encontrando nombre de color seleccionado
            var selectedColorName = originalClonedAttributesArray[0].value[this.clonedFormData.extensioncolor];

            //Hallando tallas disponibles para ese color
            var availableSizesToColor = this.colorSizeRelationArray[selectedColorName];

            // Crear copia del array de tallas
            const copyArray = angular.copy(originalClonedAttributesArray[1].value);

            //Hallando claves en array de tallas
            const sizeAvailableKeys = [];
            availableSizesToColor.forEach(function(item) {
                const foundItem = Object.keys(copyArray).find(key => copyArray[key] === item);
                if(foundItem != undefined) { sizeAvailableKeys.push(foundItem); }
            });

            //hallando llaves a borrar
            const keysToDelete = [];
            Object.keys(copyArray).forEach(function(key) {
                const keyFounded = sizeAvailableKeys.find(el => el === key);
                if(keyFounded == undefined) { keysToDelete.push(key); }
            });

            //Borrando claves de array de tallas
            keysToDelete.forEach(function(key) {
                delete copyArray[key];
            });

            this.productDetail.clonedAttributesDetail[1].value = angular.copy(copyArray);
            this.productTemplateCopy.clonedAttributesDetail[1].value = angular.copy(copyArray);
        }
        this.clonedFormData.extensiontalla = null;
    }

}

ProductDetailController.$inject = inject;

export default ProductDetailController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/product-detail/product-detail.controller.js
 **/